module.exports = __webpack_public_path__ + "static/media/bd.ab9f21dd.jpeg";